import type { AuthPagesLoginUserGeneralMutationMutation } from '@/views/Auth/graphql/AuthPagesLoginUserGeneralMutation.v5.generated';

type TLoginUserGeneralPayload =
  AuthPagesLoginUserGeneralMutationMutation['security']['login_user_general'];

export type TLoginOutcome =
  | { kind: 'success'; next_url: string }
  | { kind: 'error'; message?: string };

// security_options lives on the success branch (LoginMutationPayload) but this
// view has no post-login side effects to gate on it (no amplitude / recently-logged
// / cart-reminder calls here, verified), so it is deliberately left unused.
export const resolveLoginUserGeneralResult = (
  payload: TLoginUserGeneralPayload,
): TLoginOutcome => {
  if ('next_url' in payload) {
    return { kind: 'success', next_url: payload.next_url };
  }

  return { kind: 'error', message: payload.errors[0] };
};
